import React from 'react';

import { connect } from 'react-redux';

const UserAvatar = React.createClass({
  shouldComponentUpdate(nextProps, nextState) {
    return !this.props.state.avatars.avatarsFetched || (nextProps.userId !== this.props.userId);
  },
  render() {
    const avatars = this.props.state.avatars.userAvatars;
    const { firstName, lastName, userId, size } = this.props;
    const letters = this.getAvatarLetters(firstName, lastName);
    const currentAvatar = avatars[userId];
    const imgUrl = currentAvatar ? currentAvatar.url : null;
    const diskNumber = currentAvatar ? currentAvatar.icon_id : null;
    const diskClass = imgUrl ? '' : `avatar-${diskNumber}`;
    return (
      <a href={`/profile/public/${userId}`} className={`avatar ${diskClass} ${size || ""}`}>
        { imgUrl ?
          <img src={imgUrl} alt={letters} />
        :
          <span>{letters}</span>
        }
      </a>
    );
  },
  getAvatarLetters(firstName, lastName) {
    const firstLetter = firstName && firstName.length ? firstName.charAt(0) : "";
    let lastLetter = '';

    if (lastName) {
      lastLetter = lastName && lastName.charAt(0);
    } else {
      const strParts = firstName.split(' ');
      if (strParts.length > 1) {
        lastLetter = strParts[1].charAt(0);
      }
    }
    return firstLetter + lastLetter;
  }
});

function mapStateToProps(state) {
  return {
    state: {
      avatars: state.avatars
    }
  }
}

const connectedUserAvatar = connect(mapStateToProps)(UserAvatar);

export default connectedUserAvatar;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/avatars/components.es6